import React from 'react';
import { Modal, Box } from "@mui/material";
import Button from '../../../components/Button';
import { useDispatch } from "react-redux";
import {
  consultaMassivaRequest
} from "../../../reducers/consultaMassiva.reducer";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const StatusModal = ({ open = true, handleClose }) => {
  const dispatch = useDispatch();
  const onSubmit = async () => {
    dispatch(consultaMassivaRequest())
    handleClose()
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
          <Box sx={{ mt: 2 }}>
            <h3>Deseja executar a API de consulta do Bradesco?</h3>
          </Box>
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={handleClose} sx={{ mr: 1 }}>
              Cancelar
            </Button>
            <Button onClick={onSubmit} variant="contained" color="primary">
              Confirmar
            </Button>
          </Box>
      </Box>
    </Modal>
  );
};

export default StatusModal;
